import useCurrentUser from '../queries/currentUser/useCurrentUser'

const useCurrentUserProfileSettingSelector = (setting) => {
  const currentUser = useCurrentUser()

  if (currentUser?.data?.settings) {
    return Object.fromEntries(currentUser?.data?.settings)?.[setting]?.replace('#', '')
  }

  return undefined
}

export default useCurrentUserProfileSettingSelector
